module.exports = __webpack_public_path__ + "static/media/add-user.4483017d.svg";